import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import { resetCart } from "../../redux/orebiSlice";
import { emptyCart } from "../../assets/images/index";
import ItemCard from "./ItemCard";
import brochurePDF from "../../assets/brochure (7).pdf"; // Brochure PDF

const Cart = () => {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.orebiReducer.products);
  const [totalAmt, setTotalAmt] = useState(0);
  const [shippingCharge, setShippingCharge] = useState(0);

  useEffect(() => {
    let price = 0;
    products.forEach((item) => {
      price += item.price * item.quantity;
    });
    setTotalAmt(price);
  }, [products]);

  useEffect(() => {
    if (totalAmt <= 200 && totalAmt > 0) setShippingCharge(30);
    else if (totalAmt <= 400) setShippingCharge(25);
    else if (totalAmt > 400) setShippingCharge(20);
    else setShippingCharge(0);
  }, [totalAmt]);

  const whatsappLink = "https://wa.me/971542660433"; // WhatsApp enquiry

  return (
    <div className="max-w-container mx-auto px-4 py-10">
      <Breadcrumbs title="Cart" />
      {products.length > 0 ? (
        <div className="pb-20">
          {/* Cart table header */}
          <div className="hidden lgl:grid grid-cols-5 gap-4 bg-[#F5F7F7] text-primeColor px-6 py-4 font-titleFont font-semibold text-lg">
            <h2 className="col-span-2">Product</h2>
            <h2>Price</h2>
            <h2>Quantity</h2>
            <h2>Sub Total</h2>
          </div>

          {/* Cart items */}
          <div className="mt-5 space-y-4">
            {products.map((item) => (
              <ItemCard key={item._id} item={item} />
            ))}
          </div>

          {/* Reset cart button */}
          <div className="mt-4 flex gap-4 flex-wrap">
            <button
              onClick={() => dispatch(resetCart())}
              className="py-2 px-6 bg-red-500 text-white font-semibold uppercase hover:bg-red-700 duration-300 rounded"
            >
              Reset Cart
            </button>

            {/* Download Brochure */}
            <a
              href={brochurePDF}
              download="BCC_Mart_Brochure.pdf"
              className="py-2 px-6 bg-green-600 text-white font-semibold uppercase hover:bg-green-800 duration-300 rounded"
            >
              Download Brochure
            </a>

            {/* WhatsApp Enquiry */}
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="py-2 px-6 bg-blue-600 text-white font-semibold uppercase hover:bg-blue-800 duration-300 rounded"
            >
              WhatsApp Enquiry
            </a>
          </div>

          {/* Coupon & Update Cart */}
          <div className="flex flex-col mdl:flex-row justify-between border py-4 px-4 items-center gap-4 mdl:gap-0 mt-6">
            <div className="flex items-center gap-4">
              <input
                className="w-44 mdl:w-52 h-10 px-4 border text-primeColor text-sm outline-none border-gray-400 rounded"
                type="text"
                placeholder="Coupon Number"
              />
              <button className="text-sm mdl:text-base font-semibold text-white bg-primeColor px-4 py-2 rounded hover:bg-black duration-300">
                Apply Coupon
              </button>
            </div>
            <p className="text-lg font-semibold">Update Cart</p>
          </div>

          {/* Cart totals */}
          <div className="flex justify-end mt-6">
            <div className="w-full mdl:w-96 flex flex-col gap-4 bg-white shadow-md rounded p-4">
              <h1 className="text-2xl font-semibold text-right">Cart Totals</h1>
              <div className="space-y-2">
                <p className="flex justify-between border-b pb-1 text-lg font-medium">
                  Subtotal
                  <span className="font-semibold">${totalAmt}</span>
                </p>
                <p className="flex justify-between border-b pb-1 text-lg font-medium">
                  Shipping
                  <span className="font-semibold">${shippingCharge}</span>
                </p>
                <p className="flex justify-between text-lg font-bold pt-1">
                  Total
                  <span className="font-bold">${totalAmt + shippingCharge}</span>
                </p>
              </div>

              <div className="flex justify-end mt-4">
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full h-10 bg-primeColor text-white rounded-md hover:bg-black duration-300 flex items-center justify-center"
                >
                  Proceed via WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.4 }}
          className="flex flex-col mdl:flex-row justify-center items-center gap-4 pb-20"
        >
          <div>
            <img
              className="w-80 rounded-lg p-4 mx-auto"
              src={emptyCart}
              alt="emptyCart"
            />
          </div>
          <div className="max-w-[500px] p-4 py-8 bg-white flex flex-col items-center gap-4 rounded-md shadow-lg">
            <h1 className="font-titleFont text-xl font-bold uppercase">
              Your Cart feels lonely.
            </h1>
            <p className="text-sm text-center px-10 -mt-2">
              Your shopping cart lives to serve. Give it purpose – add products and make it happy!
            </p>

            <div className="flex flex-col mdl:flex-row gap-4">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 rounded-md px-6 py-2 font-semibold text-white hover:bg-blue-800 duration-300"
              >
                WhatsApp Enquiry
              </a>
              <a
                href={brochurePDF}
                download="BCC_Mart_Brochure.pdf"
                className="bg-green-600 rounded-md px-6 py-2 font-semibold text-white hover:bg-green-800 duration-300"
              >
                Download Brochure
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default Cart;
